import { Modal } from '@mui/material';
import React from 'react';
import ModifyPosition from '../../components/modal/ModifyPosition';

export default function ModifyPositionModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModifyPosition onClose={onClose} />
    </Modal>
  );
}
